import { api } from './auth.service';

const negocioEventoService = {
  // Eventos visíveis na timeline (com filtro de exibir_timeline,
  // exceto eventos de etapa que sempre aparecem)
  listar: async (negocioId) => {
    const res = await api.get(`/eventos/negocio/${negocioId}`);
    return res.data;
  },

  // Todos os eventos da fase comercial (visíveis ou não) — modal Eventos
  listarTodos: async (negocioId) => {
    const res = await api.get(`/eventos/negocio/${negocioId}/todos`);
    return res.data;
  },

  // Cria anotação manual (genérico — aceita fase no body).
  // Default: fase='C' (Comercial). Pra técnica, passa fase='T'.
  criarAnotacao: async (negocioId, dados) => {
    const res = await api.post(`/eventos/negocio/${negocioId}/anotacao`, dados);
    return res.data;
  },

  // Exclui evento (lógico)
  excluirEvento: async (eventoId) => {
    const res = await api.delete(`/eventos/evento/${eventoId}`);
    return res.data;
  },
};

export default negocioEventoService;
